import React, { useState, useEffect } from "react";
import DefaultLayout from "../components/DefaultLayout";
import { useDispatch, useSelector } from "react-redux";
import { getAllBookings, cancelBooking } from "../redux/actions/bookingActions";
import { Col, Row, Popconfirm } from "antd";
import Spinner from '../components/Spinner';
import moment from "moment";
function UserBookings() {
  const dispatch = useDispatch();
  const { bookings } = useSelector((state) => state.bookingsReducer);
  const {loading} = useSelector((state) => state.alertsReducer);
  const user = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    dispatch(getAllBookings());
  }, []);

  const myBookings = bookings.filter(o=>o.user==user._id)

  return (
    <DefaultLayout>
        {loading && (<Spinner />)}
      <h3 className="text-center mt-2">My Bookings</h3>
    
      <Row justify="center" gutter={16}>
        <Col lg={16} sm={24}>

            {myBookings.length === 0 && !loading && (
                <div className="empty-state">
                    <p>No bookings yet — go book your first car!</p>
                </div>
            )}
         
            {myBookings.map((booking) => {
             const isPast = moment(booking.bookedTimeSlots.to).isBefore(moment())
             return <Row gutter={16} className="booking-card bs1 mt-3 text-left" key={booking._id}>
                <Col lg={5} sm={24}>
                    <img style={{borderRadius:10}} src={booking.car.image}  width="100%" height="120" className="p-2" style={{objectFit:'cover', borderRadius:10}}/>
                </Col>

                <Col lg={7} sm={24}>
                    <p><b>{booking.car.name}</b></p>
                    <p>Total hours : <b>{booking.totalHours}</b></p>
                    <p>Rent per hour : <b>₹{booking.car.rentPerHour}</b></p>
                    <p>Total amount : <b>₹{booking.totalAmount}</b></p>
                </Col>

                <Col lg={9} sm={24}>
                <p>Transaction Id : <b>{booking.transactionId}</b></p>
                <p>From: <b>{booking.bookedTimeSlots.from}</b></p>
                <p>To: <b>{booking.bookedTimeSlots.to}</b></p>
                <p>Date of booking: <b>{moment(booking.createdAt).format('MMM DD yyyy')}</b></p>
                </Col>

                <Col lg={3} sm={24} className='text-right d-flex align-items-center justify-content-center'>
                    {isPast ? (
                        <span className="booking-status-past">Completed</span>
                    ) : (
                        <Popconfirm
                            title="Cancel this booking?"
                            description="This action cannot be undone."
                            onConfirm={()=>dispatch(cancelBooking(booking._id))}
                            okText="Yes, cancel"
                            cancelText="No"
                        >
                            <button className="cancel-btn">Cancel</button>
                        </Popconfirm>
                    )}
                </Col>
              </Row>;
            })}
          
        </Col>
      </Row>
    </DefaultLayout>
  );
}

export default UserBookings;
